export default __webpack_public_path__ + "static/media/static_img_scenario_legend.3f7c3209.png";